import { render, staticRenderFns } from "./ResultSkeleton.vue?vue&type=template&id=e4f0d532&scoped=true&"
import script from "./ResultSkeleton.vue?vue&type=script&lang=js&"
export * from "./ResultSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ResultSkeleton.vue?vue&type=style&index=0&id=e4f0d532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f0d532",
  null
  
)

export default component.exports